import angular from 'angular';
import RequestFactory from './request.factory';

const MODULE_NAME = 'buscador.interceptores';

const ngModule=angular.module(MODULE_NAME, []);

ngModule.factory('requestFactory',['$q', 'urlConfig',($q,urlConfig)=>new RequestFactory($q,urlConfig)] );

export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/interceptores/index.js